import React from 'react';
import ProjectTable from '../../components/projectTable';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import McListTableRow from '../../components/mcListTableRow';
import { ReactComponent as PendingIcon } from '../../../assets/svg/pending.svg';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import { ReactComponent as CriticalP } from '../../../assets/svg/critical_priority.svg';
import { ReactComponent as HighP } from '../../../assets/svg/arrow-up.svg';
import { ReactComponent as Download } from '../../../assets/svg/download-btn.svg';
import { ReactComponent as LowP } from '../../../assets/svg/red-low.svg';
import { ReactComponent as MediumP } from '../../../assets/svg/medium_priority.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import { ReactComponent as Info } from '../../../assets/svg/info-svg.svg';
import _, { debounce, times } from 'lodash';
import DatePicker from 'react-datepicker';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import { gql } from '@apollo/client';
import moment from 'moment';
import EditTask from '../../components/tasks/editTask';
import CreateTask from '../../components/tasks/createTask';
import { Space } from 'antd';
import LabelCard from '../Deliverables/LabelCard';
import DownloadAttendance from '../../components/DownloadAttendance';
import AttendanceFormatTable from '../../components/AttendanceFormatTable';
import { formatEmpAttHours } from '../../../utils/common';

const getEmployeesAttendanceList = gql`
	query EmployeesAttendance($filters: attendanceListFiltersInput) {
		employeesAttendance(filters: $filters) {
			currentPage
			data {
				id
				fullName
				dp_signed_url
				department
				updatedAt
				date
				logins {
					timestamp
				}
				totalHours
				status
				workspaceId
				divisionId
				logouts {
					timestamp
				}
			}
			hasNextPage
			hasPrevPage
			limit
			nextPage
			prevPage
			totalDocs
			totalPages
		}
	}
`;
const getEmployeesAttendanceCount = gql`
	query AttendanceDefaultFilters($filters: attendanceDefaultFiltersInput) {
		attendanceDefaultFilters(filters: $filters) {
			totalEmployees
			present
			absent
			notMarked
			onTime
		}
	}
`;
const getEmployeeAttendanceFilters = gql`
	query Attendancefilters {
		attendancefilters {
			department
			divisionId
		}
	}
`;
class Attendance extends ProjectsGraphQlController {
	constructor() {
		super();
		this.calRef = React.createRef(null);
		this.state = {
			isLoading: true,
			hoveredRows: Array(2).fill(false),
			hoveredRows2: Array(2).fill(false),
			startDate: new Date(),
			endDate: new Date(),
			limit: 20,
			page: 1,
			search: '',
			currentViewPage: 1,
			employeesAttendanceList: [],
			employeesAttendanceCount: {},
			departmentOptions: [],
			officeOptions: [],
			officeActiveFilter: null,
			departmentActiveFilter: null,
			activeAttendanceStatus: null,
			downloadAttendanceModal: false,
			columns: [
				// { title: 'FLAG' },

				{ title: 'Employee', className: 'wedding-details-column' },
				{ title: 'Brand', className: 'wedding-details-column' },
				{ title: 'Attendance State', className: 'wedding-details-column' },

				{ title: 'Clock In', className: 'wedding-details-column' },
				{ title: 'Clock Out', className: 'wedding-details-column' },
				{ title: 'Working Hours', className: 'wedding-details-column' },
				{ title: 'Last Activity', className: 'wedding-details-column' },
				// { title: 'Overtime', className: 'wedding-details-column' },
				// { title: 'Fine', className: 'wedding-details-column' },
			],
		};
	}
	handleMouseEnter = (index) => {
		const newHoveredRows = [...this.state.hoveredRows];
		newHoveredRows[index] = true;
		this.setState({ hoveredRows: newHoveredRows });
	};

	handleMouseLeave = (index) => {
		const newHoveredRows = [...this.state.hoveredRows];
		newHoveredRows[index] = false;
		this.setState({ hoveredRows: newHoveredRows });
	};
	handleMouseEnter2 = (index) => {
		const newHoveredRows = [...this.state.hoveredRows2];
		newHoveredRows[index] = true;
		this.setState({ hoveredRows2: newHoveredRows });
	};

	handleMouseLeave2 = (index) => {
		const newHoveredRows = [...this.state.hoveredRows2];
		newHoveredRows[index] = false;
		this.setState({ hoveredRows2: newHoveredRows });
	};

	applyFilter = (filter, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: filter,
				currentViewPage: 1,
				employeesAttendanceList: [],
				isPageLoading: true,
			},
			() => {
				this.fetchMoreAttList();
			},
		);
	};

	componentDidMount = () => {
		let json = {};
		let json2 = {};
		let urlSearch =
			_.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];
		if (_.size(urlSearch) > 0) {
			let count = 0;

			let tempUrlSearch = _.cloneDeep(urlSearch);

			while (count < _.size(urlSearch)) {
				let subString = urlSearch[count].split('=');

				if (subString[0] && (subString[0] === 'page' || subString[0] === 'limit')) {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: parseInt(subString[1]),
						},
					};
				}
				if (subString[0] && subString[0] === 'activeDate') {
					json = {
						...json,
						filters: {
							...json.filters,

							startDate: parseInt(subString[1]),
							endDate: parseInt(subString[1]),
						},
					};
					json2 = {
						...json2,
						filters: {
							...json2.filters,

							startDate: parseInt(subString[1]),
							endDate: parseInt(subString[1]),
						},
					};
				}
				if (subString[0] && subString[0] === 'departmentActiveFilter') {
					json = {
						...json,
						filters: {
							...json.filters,

							department: subString[1],
						},
					};
					json2 = {
						...json2,
						filters: {
							...json2.filters,

							department: subString[1],
						},
					};
				}
				if (subString[0] && subString[0] === 'officeActiveFilter') {
					json = {
						...json,
						filters: {
							...json.filters,

							divisionId: subString[1],
						},
					};
					json2 = {
						...json2,
						filters: {
							...json2.filters,

							divisionId: subString[1],
						},
					};
				}
				if (subString[0] && subString[0] === 'activeAttendanceStatus') {
					json = {
						...json,
						filters: {
							...json.filters,

							status: subString[1],
						},
					};
				}

				if (subString[0] && subString[0] === 'search') {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: subString[1],
						},
					};
				}

				if (subString[0] === 'page' || subString[0] === 'limit') {
					if (subString[0] === 'page') {
						this.setState({
							currentViewPage: parseInt(subString[1]),
						});
					} else {
						this.setState({
							[subString[0]]: parseInt(subString[1]),
						});
					}
				}
				if (
					subString[0] &&
					(subString[0] === 'departmentActiveFilter' ||
						subString[0] === 'officeActiveFilter')
				) {
					this.setState({
						[subString[0]]: subString[1],
					});
				}

				if (subString[0] && subString[0] === 'search') {
					this.setState({
						[subString[0]]: subString[1],
					});
				}
				if (subString[0] && subString[0] === 'activeDate') {
					this.setState({
						startDate: moment(subString[1], 'YYYYMMDD').toDate(),
					});
				}
				if (subString[0] && subString[0] === 'activeAttendanceStatus') {
					this.setState({
						// startDate: moment(subString[1].toString(), 'YYYYMMDD').format(
						// 	'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (India Standard Time)',
						// ),
						[subString[0]]: subString[1],
					});
				}

				count++;
			}
		} else {
			json = {
				filters: {
					limit: this.state.limit,
					page: this.state.currentViewPage,
					startDate: parseInt(moment(this.state.startDate).format('YYYYMMDD')),
					endDate: parseInt(moment(this.state.startDate).format('YYYYMMDD')),
				},
			};
			json2 = {
				filters: {
					startDate: parseInt(moment(this.state.startDate).format('YYYYMMDD')),
					endDate: parseInt(moment(this.state.startDate).format('YYYYMMDD')),
				},
			};
		}
		this.getEmployeeAttendanceFilters(getEmployeeAttendanceFilters);
		this.getEmployeesAttendanceList(getEmployeesAttendanceList, json);
		this.getEmployeesAttendanceCount(getEmployeesAttendanceCount, json2);
		// this.getTenantUsers(getTenantUserList);
		// this.getProjectsList2(getProjects, {
		// 	filters: {
		// 		limit: 1000,
		// 		page: 1,
		// 	},
		// });
		// this.getVendorsWorkspaces(getVendorInfo, {
		// 	vendorId: this.props.params.vendorID,
		// });
		// this.getTaskFlags(getTaskFlags);
		// this.getTenantUsers(getTenantUserList);
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreAttList();
				},
			);
		}
	};
	handleAttStatus = async (status) => {
		this.setState(
			{
				currentViewPage: 1,
				isPageLoading: true,
				activeAttendanceStatus: this.state.activeAttendanceStatus == status ? null : status,
			},
			async () => {
				await this.fetchMoreAttList();
			},
		);
	};

	handleGoToPage = async (e) => {
		this.setState(
			{
				currentViewPage: e,
				isPageLoading: true,
			},
			async () => {
				await this.fetchMoreAttList();
			},
		);
	};
	onClickPreviousPage = async () => {
		if (this.state.currentViewPage > 1) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage - 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreAttList();
				},
			);
		}
	};
	fetchMoreAttList = async () => {
		let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`;
		let dateString = moment(this.state.startDate).format('YYYYMMDD');
		queryString = `${queryString}&activeDate=${dateString}`;
		if (this.state.officeActiveFilter && this.state.officeActiveFilter.length !== 0)
			queryString = `${queryString}&officeActiveFilter=${this.state.officeActiveFilter.toString()}`;
		if (this.state.departmentActiveFilter && this.state.departmentActiveFilter.length !== 0)
			queryString = `${queryString}&departmentActiveFilter=${this.state.departmentActiveFilter.toString()}`;
		if (this.state.activeAttendanceStatus && this.state.activeAttendanceStatus.length !== 0)
			queryString = `${queryString}&activeAttendanceStatus=${this.state.activeAttendanceStatus.toString()}`;
		// if (this.state.scopeActiveFilter.length !== 0)
		// 	queryString = `${queryString}&scope=${this.state.scopeActiveFilter}`;
		// if (this.state.workspaceActiveFilter.length !== 0)
		// 	queryString = `${queryString}&tenantId=${this.state.workspaceActiveFilter.toString()}`;
		if (this.state.search.length !== 0)
			queryString = `${queryString}&search=${this.state.search.toString()}`;
		// if (this.state.activeFlag.length !== 0)
		// 	queryString = `${queryString}&activeFlag=${this.state.activeFlag.toString()}`;
		this.props.navigate(`/${this.props.params.vendorID}/attendance${queryString}`);

		let filters = {
			filters: {
				page: this.state.currentViewPage,
				limit: this.state.limit,
				startDate: parseInt(moment(this.state.startDate).format('YYYYMMDD')),
				endDate: parseInt(moment(this.state.startDate).format('YYYYMMDD')),
			},
		};
		let json = {};
		json = {
			filters: {
				startDate: parseInt(moment(this.state.startDate).format('YYYYMMDD')),
				endDate: parseInt(moment(this.state.startDate).format('YYYYMMDD')),
			},
		};
		if (this.state.officeActiveFilter && this.state.officeActiveFilter.length !== 0) {
			filters = {
				...filters,
				filters: {
					...filters.filters,
					divisionId: this.state.officeActiveFilter,
				},
			};
			json = {
				...json,
				filters: {
					...json.filters,
					divisionId: this.state.officeActiveFilter,
				},
			};
		}
		if (this.state.departmentActiveFilter && this.state.departmentActiveFilter.length !== 0) {
			filters = {
				...filters,
				filters: {
					...filters.filters,
					department: this.state.departmentActiveFilter,
				},
			};
			json = {
				...json,
				filters: {
					...json.filters,
					department: this.state.departmentActiveFilter,
				},
			};
		}
		if (this.state.activeAttendanceStatus && this.state.activeAttendanceStatus.length !== 0) {
			filters = {
				...filters,
				filters: {
					...filters.filters,
					status: this.state.activeAttendanceStatus,
				},
			};
		}
		// if (this.state.scopeActiveFilter.length !== 0) {
		// 	filters = {
		// 		...filters,
		// 		filters: {
		// 			...filters.filters,
		// 			scope: this.state.scopeActiveFilter,
		// 		},
		// 	};
		// 	json = {
		// 		...json,
		// 		filters: {
		// 			...json.filters,
		// 			scope: this.state.scopeActiveFilter,
		// 		},
		// 	};
		// }
		// if (this.state.workspaceActiveFilter.length !== 0) {
		// 	filters = {
		// 		...filters,
		// 		filters: {
		// 			...filters.filters,
		// 			tenantId: this.state.workspaceActiveFilter,
		// 		},
		// 	};
		// 	json = {
		// 		...json,
		// 		filters: {
		// 			...json.filters,
		// 			tenantId: this.state.workspaceActiveFilter,
		// 		},
		// 	};
		// }
		if (this.state.search.length !== 0) {
			filters = {
				...filters,
				filters: {
					...filters.filters,
					search: this.state.search,
				},
			};
			// json = {
			// 	...json,
			// 	filters: {
			// 		...json.filters,
			// 		search: this.state.search,
			// 	},
			// };
		}
		// if (this.state.activeFlag !== '' && this.state.activeFlag.length > 0) {
		// 	filters = {
		// 		...filters,
		// 		filters: {
		// 			...filters.filters,
		// 			statusFilters: this.state.activeFlag,
		// 		},
		// 	};
		// }
		this.setState({
			isLoading: true,
		});
		console.log('debugging filters for task flags--->', json);
		// this.getTaskFlags(getTaskFlags, json);
		await this.getEmployeesAttendanceList(getEmployeesAttendanceList, filters);
		await this.getEmployeesAttendanceCount(getEmployeesAttendanceCount, json);
	};

	handleActiveFilter = (e, type, key) => {
		let array;
		if (type === 'project' || type === 'status') {
			array = this.state[`${type}ActiveFilter`] === key ? '' : key;
		} else {
			array = [...this.state[`${type}ActiveFilter`]];

			if (array.includes(key) == false) {
				array.push(key);
			} else {
				const index = array.indexOf(key);
				if (index > -1) {
					array.splice(index, 1); // 2nd parameter means remove one item only
				}
			}
		}
		this.setState(
			{
				[`${type}ActiveFilter`]: array,
				currentViewPage: 1,
				shootList: [],
				isPageLoading: true,
			},
			() => this.fetchMoreShoots(),
		);
	};

	handleclearSelection = (e, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: null,
				currentViewPage: 1,

				isPageLoading: true,
			},
			() => {
				this.fetchMoreAttList();
			},
		);
	};

	openDownloadModal = (type) => {
		this.setState({
			downloadAttendanceModal: type,
		});
	};

	render() {
		console.log(
			'active filters--->',
			this.state.departmentActiveFilter,
			this.state.officeActiveFilter,
		);
		return (
			<div className="layout-wrapper">
				{this.state.isLoading ? (
					//     ||
					// this.state.taskFlags === null ||
					// this.state.statusFlags === null ||
					// this.state.assignedToFilters === null
					<>
						<LoadingBar />
					</>
				) : (
					<div className="container">
						<div className="searchContainer">
							<div className="shoots-header-filters-container">
								<Filter
									type={'office'}
									label={'Office'}
									version="v2"
									filters={this.state.officeOptions}
									activeFilter={this.state.officeActiveFilter}
									// handleActiveFilter={(e, status, key) =>
									// 	this.handleActiveFilter(e, 'workspace', key)
									// }
									clearSelection={(e) => this.handleclearSelection(e, 'office')}
									isMultipleSelectable={false}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'department'}
									label={'Department'}
									version="v2"
									filters={this.state.departmentOptions}
									activeFilter={this.state.departmentActiveFilter}
									// handleActiveFilter={(e, status, key) =>
									// 	this.handleActiveFilter(e, 'workspace', key)
									// }
									clearSelection={(e) =>
										this.handleclearSelection(e, 'department')
									}
									isMultipleSelectable={false}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								{/* <Filter
									type={'staffType'}
									label={'Staff Type'}
									version="v2"
									// filters={this.state.scopeFilters}
									// activeFilter={this.state.scopeActiveFilter}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'staffType')
									}
									isMultipleSelectable={false}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/> */}
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									gap: '10px',
								}}
							>
								<div className="searchWrapper">
									<div className="search-inner-left">
										<span className="search-icon">
											<SearchIcon />
										</span>
										<input
											placeholder="Search"
											value={this.state.search}
											onChange={(e) => {
												this.setState({
													search: e.target.value,
												});
											}}
											onKeyDown={(e) => {
												if (e.key === 'Enter') {
													this.fetchMoreAttList();
												}
											}}
										/>
									</div>
									<div className="search-inner-right">
										<span className="search-dropdown-btn">
											<a
												className="search-type"
												onClick={(e) => {
													this.fetchMoreAttList();
												}}
											>
												Search
											</a>
										</span>
									</div>
								</div>
								{/* <div
									className="create-shoot-btn"
									onClick={(e) => this.showCreateTaskModal()}
								>
									+ Create Task
								</div> */}
							</div>
						</div>
						<div className="filters">
							{' '}
							<div
								style={{
									display: 'flex',
									width: '100%',
									justifyContent: 'space-between',
									color: 'white',
								}}
							>
								<div className="left-filter-section">
									{/* <div
										className="filterbox"
										style={{
											backgroundColor: '#6055EC',
										}}
									>
										Daily
									</div>
									<div
										className="filterbox"
										style={{
											backgroundColor: '#272727',
										}}
									>
										Monthly
									</div> */}
									<div className="datePicker">
										<div className="dp-container">
											<DatePicker
												// inline
												placeholderText={'Day: 26 October 2023'}
												ref={this.calRef}
												selected={this.state.startDate}
												shouldCloseOnSelect={false}
												// onChange={this.onChange}
												dayClassName={() => 'example-datepicker-day-class'}
												popperClassName="example-datepicker-class"
												// todayButton="TODAY"
												onChange={(date) => {
													this.setState({
														startDate: date,
													});
													console.log('checking selected date', date);
												}}
											>
												{' '}
												<div
													className=""
													style={{
														marginLeft: '80px',
													}}
												>
													<button
														style={{
															marginLeft: '10px',
															cursor: 'pointer',
															backgroundColor: '#F5F5F5',
															borderRadius: '4px',
															// color: 'white',
															border: 'none',
															padding: '6px 8px',
														}}
														onClick={() => {
															this.calRef.current.setOpen(false);
															this.setState({
																showCustomDate: false,
																startDate: new Date(),
															});
														}}
													>
														Cancel
													</button>
													<button
														style={{
															marginLeft: '10px',
															cursor: 'pointer',
															backgroundColor: '#2153CC',
															borderRadius: '4px',
															color: 'white',
															border: 'none',
															padding: '6px 8px',
														}}
														onClick={() => {
															this.calRef.current.setOpen(false);
															this.fetchMoreAttList();
														}}
													>
														Apply
													</button>
												</div>
											</DatePicker>
										</div>
									</div>
								</div>
								<div>
									<div
										className="datePicker"
										style={{
											alignItems: 'center',
										}}
									>
										{/* <div className="dp-container">
											<DatePicker
												// inline
												placeholderText={'Day: 26 October 2023'}
												ref={this.calRef}
												selected={
													this.state.startDate
														? this.state.startDate
														: new Date()
												}
												shouldCloseOnSelect={false}
												onChange={this.onChange}
												startDate={this.state.startDate}
												endDate={this.state.endDate}
												selectsRange
												dayClassName={() => 'example-datepicker-day-class'}
												popperClassName="example-datepicker-class"
												// todayButton="TODAY"
												// onChange={(date) => {
												//     this.setState({
												//         startDate: date,
												//     })
												// }}
											>
												{' '}
												<div
													className=""
													style={{
														marginLeft: '80px',
													}}
												>
													<button
														style={{
															marginLeft: '10px',
															cursor: 'pointer',
															backgroundColor: '#F5F5F5',
															borderRadius: '4px',
															// color: 'white',
															border: 'none',
															padding: '6px 8px',
														}}
														onClick={() => {
															this.calRef.current.setOpen(false);
															this.setState({
																showCustomDate: false,
																currStatus: this.state.prevStatus,
															});
														}}
													>
														Cancel
													</button>
													<button
														style={{
															marginLeft: '10px',
															cursor: 'pointer',
															backgroundColor: '#2153CC',
															borderRadius: '4px',
															color: 'white',
															border: 'none',
															padding: '6px 8px',
														}}
														onClick={() => {
															this.calRef.current.setOpen(false);
															this.handleCUstomDateSelection();
														}}
													>
														Apply
													</button>
												</div>
											</DatePicker>
										</div> */}

										{/* <div
											style={{
												padding: '10px 16px',
												borderRadius: '40px',
												background: '#6055EC',
												display: 'flex',
												alignItems: 'center',
												gap: '6px',
											}}
										>
											<p
												style={{
													color: '#EFEFEF',
													fontFamily: 'Inter',
													fontSize: '13px',
													fontStyle: 'normal',
													fontWeight: 500,
													lineHeight: '16px',
													letterSpacing: '-0.3px',
												}}
											>
												Download Report
											</p>
											<Download />
										</div> */}
									</div>
								</div>
							</div>{' '}
						</div>
						<div
							className="filters2"
							style={{
								zIndex: '1',
							}}
						>
							<div
								style={{
									display: 'flex',
									width: '100%',
									// justifyContent: 'space-between',
									gap: '16px',
									marginTop: '10px',
								}}
							>
								<div
									className="insightBox"
									onClick={() =>
										this.handleAttStatus(this.state.activeAttendanceStatus)
									}
									style={{
										backgroundColor:
											this.state.activeAttendanceStatus === null
												? 'rgb(45, 42, 80)'
												: '',
									}}
								>
									<p className="firstText">Total Employees</p>
									<div className="second-box">
										<p className="number-text">
											{this.state.employeesAttendanceCount.totalEmployees}
										</p>
									</div>
								</div>
								<div
									className="insightBox"
									onClick={() => this.handleAttStatus('present')}
									style={{
										backgroundColor:
											this.state.activeAttendanceStatus === 'present'
												? 'rgb(45, 42, 80)'
												: '',
									}}
								>
									<p className="firstText">Present </p>
									<div className="second-box">
										<p className="number-text">
											{this.state.employeesAttendanceCount.present}
										</p>
										{/* <HighP /> */}
									</div>
								</div>
								<div
									className="insightBox"
									onClick={() => this.handleAttStatus('absent')}
									style={{
										backgroundColor:
											this.state.activeAttendanceStatus === 'absent'
												? 'rgb(45, 42, 80)'
												: '',
									}}
								>
									<p className="firstText">Absent </p>
									<div className="second-box">
										<p className="number-text">
											{this.state.employeesAttendanceCount.absent}
										</p>
										{/* <LowP /> */}
									</div>
								</div>
								<div
									className="insightBox"
									onClick={() => this.handleAttStatus('notMarked')}
									style={{
										backgroundColor:
											this.state.activeAttendanceStatus === 'notMarked'
												? 'rgb(45, 42, 80)'
												: '',
									}}
								>
									<p className="firstText">Not Marked</p>
									<div className="second-box">
										<p className="number-text">
											{this.state.employeesAttendanceCount.notMarked}
										</p>
										{/* <HighP /> */}
									</div>
								</div>
								<div
									className="insightBox"
									onClick={() => this.handleAttStatus('onTime')}
									style={{
										backgroundColor:
											this.state.activeAttendanceStatus === 'onTime'
												? 'rgb(45, 42, 80)'
												: '',
									}}
								>
									<p className="firstText">On Time</p>
									<div className="second-box">
										<p className="number-text">
											{this.state.employeesAttendanceCount.onTime}
										</p>
										{/* <LowP /> */}
									</div>
								</div>
								<div style={{ marginRight: '1rem', paddingTop: '1rem' }}>
									<AttendanceFormatTable
										modalState={this.openDownloadModal}
										isModalOpen={this.state.downloadAttendanceModal}
									/>
								</div>
							</div>
						</div>
						<div
							className={'table tenant-users-table'}
							style={{
								top: '282px',
							}}
						>
							<ProjectTable
								attendance={true}
								tableHeaderLeftPad={35}
								isLoading={this.state.isLoading}
								tableHeader={`SHOOTS`}
								columns={this.state.columns}
								// activeSortType={this.state.sortType}
								// activeSortBy={this.state.sortBy}
								//handleSort={this.handleProjectSort}
								// isPageLoading={this.state.isPageLoading}
								limit={this.state.limit}
								totalPages={this.state.totalPages}
								currentViewPage={this.state.currentViewPage}
								lengthOfList={this.state.lengthOfList}
								onClickNextPage={this.onClickNextPage}
								onClickPreviousPage={this.onClickPreviousPage}
								dataList={this.state.employeesAttendanceList}
								goToPage={(e) => this.handleGoToPage(e)}
								module={'project'}
								searchQuery={''}
								mainFilter={''}
							>
								{this.state.employeesAttendanceList.length > 0 &&
									_.map(this.state.employeesAttendanceList, (empAtt, index) => {
										return (
											<tr
												onClick={() => {
													this.props.navigate(
														`/${this.props.params.vendorID}/attendance/${empAtt.id}`,
													);
												}}
											>
												<td>
													<div
														style={{
															display: 'flex',
															gap: '12px',
															height: '74px',
															padding: '16px 24px',
														}}
													>
														{/* <div
															style={{
																height: '40px',
																width: '40px',
																borderRadius: '50%',
																backgroundColor: 'gray',
															}}
														></div> */}
														<img
															src={empAtt.dp_signed_url}
															alt=""
															style={{
																height: '40px',
																width: '40px',
																borderRadius: '50%',
															}}
														/>
														<div
															style={{
																height: '40px',
																display: 'flex',
																flexDirection: 'column',
																justifyContent: 'space-between',
															}}
														>
															<p className="name-text">
																{empAtt.fullName}
															</p>
															<p
																className="des-text"
																style={{
																	textTransform: 'capitalize',
																}}
															>
																{empAtt.department}
															</p>
														</div>
													</div>
												</td>
												<td>
													<p
														className="brand-text"
														style={{
															textTransform: 'capitalize',
														}}
													>
														{empAtt.workspaceId}
													</p>
												</td>
												<td>
													{' '}
													<div
														className="att-state-box"
														style={{
															backgroundColor:
																empAtt?.status == 'present'
																	? '#8FDCC4'
																	: empAtt?.status == 'absent'
																	? '#F2C5BA'
																	: '#EAECF0',
															textTransform: 'capitalize',
														}}
													>
														{empAtt?.status}
													</div>
												</td>
												<td
													style={{ position: 'relative' }}
													// onMouseEnter={() => this.handleMouseEnter(0)}
													// onMouseLeave={() => this.handleMouseLeave(0)}
												>
													{' '}
													<div
														style={{
															display: 'flex',

															flexDirection: 'column',
															gap: '12px',
														}}
													>
														<p className="clock-in-out-text">
															{empAtt?.logins?.length > 0 &&
																empAtt?.logins[0]?.timestamp.substring(
																	0,
																)}
														</p>
														{empAtt?.logins?.length > 1 && (
															<p className="clock-in-out-text">
																{empAtt?.logins[1]?.timestamp.substring(
																	0,
																)}
																{empAtt?.logins?.length > 2 ? (
																	<span>
																		{' + ' +
																			(empAtt?.logins
																				?.length -
																				2)}
																	</span>
																) : null}
															</p>
														)}
													</div>
													<div
														style={{
															position: 'absolute',
															width: '236px',
															height: '52px',
															padding: '8px 12px 8px 12px',
															borderRadius: '8px',
															border: '0 0 0.5px 0',
															gap: '10px',
															backgroundColor: '#6055EC',
															color: '#FFF',
															fontFamily: 'Inter',
															fontSize: '14px',
															fontStyle: 'normal',
															fontWeight: '400',
															lineHeight: '18px',
															letterSpacing: '-0.28px',
															display: this.state.hoveredRows[0]
																? 'flex'
																: 'none',
														}}
													>
														<Info />{' '}
														<p> Your tooltip content goes here</p>
													</div>
												</td>
												<td
													style={{ position: 'relative' }}
													// onMouseEnter={() => this.handleMouseEnter2(0)}
													// onMouseLeave={() => this.handleMouseLeave2(0)}
												>
													{' '}
													<div
														style={{
															display: 'flex',

															flexDirection: 'column',
															gap: '12px',
														}}
													>
														<p className="clock-in-out-text">
															{empAtt?.logouts?.length > 0 &&
																empAtt?.logouts[0]?.timestamp.substring(
																	0,
																)}
														</p>
														{empAtt?.logouts?.length > 1 && (
															<p className="clock-in-out-text">
																{empAtt?.logouts[1]?.timestamp.substring(
																	0,
																)}
																{empAtt?.logouts?.length > 2 ? (
																	<span>
																		{' + ' +
																			(empAtt?.logouts
																				?.length -
																				2)}
																	</span>
																) : null}
															</p>
														)}
													</div>
													<div
														style={{
															position: 'absolute',
															width: '236px',
															height: '52px',
															padding: '8px 12px 8px 12px',
															borderRadius: '8px',
															border: '0 0 0.5px 0',
															gap: '10px',
															backgroundColor: '#6055EC',
															color: '#FFF',
															fontFamily: 'Inter',
															fontSize: '14px',
															fontStyle: 'normal',
															fontWeight: '400',
															lineHeight: '18px',
															letterSpacing: '-0.28px',
															display: this.state.hoveredRows2[0]
																? 'flex'
																: 'none',
														}}
													>
														<Info />{' '}
														<p> Your tooltip2 content goes here</p>
													</div>
												</td>
												<td>
													{' '}
													<div
														style={{
															display: 'flex',

															flexDirection: 'column',
															gap: '12px',
														}}
													>
														<p className="clock-in-out-text">
															{empAtt.totalHours &&
																formatEmpAttHours(
																	empAtt.totalHours,
																)}
														</p>

														{/* <p className="clock-in-out-text">10:07AM</p> */}
													</div>
												</td>
												<td>
													{' '}
													<div
														style={{
															display: 'flex',

															flexDirection: 'column',
															gap: '12px',
														}}
													>
														<p className="clock-in-out-text">
															{empAtt?.updatedAt
																? moment
																		.unix(empAtt?.updatedAt)
																		.format('DD MMMM YYYY')
																: ''}
														</p>

														{/* <p className="clock-in-out-text">10:07AM</p> */}
													</div>
												</td>
											</tr>
										);
									})}
							</ProjectTable>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default withRouter(Attendance);
